const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.07,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 2.7,
              spacing: 30,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3.05,
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
